import { createContext } from 'react';

export interface AvatarPicture {
  url?: string;
  /**
   * Should be set to true if either the picture is already loading
   * or it was loaded already. This includes also if the picture
   * could not be loaded.
   *
   * @type {boolean}
   * @memberof Picture
   */
  isRequested: boolean;
}

export interface AvatarContextProps {
  byUser: Record<string, AvatarPicture>;
  byGroup: Record<string, AvatarPicture>;
  loadUserPicture(userId: string): void;
  loadGroupPicture(groupId: string): void;
}

export const AvatarContext = createContext<AvatarContextProps>({
  byUser: {},
  byGroup: {},
  loadUserPicture: () => console.warn('No pictures provider found.'),
  loadGroupPicture: () => console.warn('No pictures provider found.'),
});
